'use strict';

DoohApps.directive('horizontalTreecontrol', ['$timeout', 'DoohConfig', function ($timeout, DoohConfig) {
    return {
        restrict: 'EA',
        scope: {
            tree: '=',
            onSelect: '&',
            newFolder: '=',
            path: '='

        },
        link: function (scope, elem) {
            scope.treeBranches = [];
            var selectedNode;
            var initialized = false;

            scope.toggleBranch = function (node, branchLevel, fromInit) {
                scope.treeBranches = scope.treeBranches.slice(0, branchLevel + 1);

                //deselect all other nodes in this level.
                scope.treeBranches[branchLevel].nodes.map(function (n) { n.node != node.node ? n.selected = false : n });

                node.selected = !node.selected;

                if (node.selected) {
                    //previously opened nodes may still be set as selected. Deselect them. 
                    //more efficient to deselect here and only one level than to go through all levels below on toggle.
                    node.children.map(function (n) { n.selected = false });
                    scope.treeBranches.push({ nodes: node.children, level: branchLevel + 1 });
                    selectedNode = node;
                    if (!fromInit)
                        scrollToEnd();
                } else {
                    //find selected node in one level up
                    selectedNode = getSelectedNode(branchLevel - 1);
                }

                if (!fromInit) {
                    updatePath(selectedNode, branchLevel);
                    scope.onSelect({ node: selectedNode });
                }

                while (scope.treeBranches.length < 4)
                    scope.treeBranches.push(null);
            }
            addScroll();

            function init(tree) {
                initialized = true;
                void 0;
                //array with 4 empty objects for design purpouse
                scope.treeBranches = new Array(4);
                //folders in Assets base directory
                scope.treeBranches[0] = { nodes: tree.children, level: 0 };
                //selec root folder as start point
                scope.onSelect({ node: tree });
                //travel through path and set select path
                setStartingPoint(scope.path);
                //need to wait a bit for DOM to load.
                $timeout(scrollToEnd, 0);
            }

            function getSelectedNode(branchLevel) {
                var branch = scope.treeBranches[branchLevel];
                if (branch != undefined)
                    return branch.nodes.filter(function (n) { return n.selected })[0];
                return scope.tree[0];
            }

            function updatePath(node, branchLevel) {
                if (scope.path[scope.path.length - 1].node == node.node)
                    return;
                var nodeIndex = scope.path.findIndex(function (p) {
                    return p.node == node.node;
                });

                scope.path = scope.path.slice(0, branchLevel + 1);
                if (nodeIndex == -1)
                    scope.path.push({ node: node.node, name: node.name });
            }

            function setStartingPoint(path) {
                if (path != null) {
                    if (path.length == 1) {
                        selectedNode = scope.tree[0];
                    } else {
                        //ignore root level
                        for (var i = 1; i < path.length; i++) {
                            //from path, find the node in tree                        
                            var node = scope.treeBranches[i - 1].nodes.filter(function (n) {
                                return n.node == path[i].node
                            })[0];
                            scope.toggleBranch(node, i - 1, i + 1 != path.length);
                        }
                    }
                }
            }

            function addScroll() {
                var overFlowEl = angular.element(document.querySelector('.treeControl-wrapper'));
                overFlowEl.mousewheel(function (e, delta) {
                    this.scrollLeft -= (delta * 60);
                    e.preventDefault();
                    e.stopPropagation();
                });
            }

            function scrollToEnd() {
                var overFlowEl = angular.element(document.querySelector('.treeControl-wrapper'));
                //get number of branches with actual data, since there can be  empty ones.
                var openedBranches = scope.treeBranches.filter(function (branch) {
                    return branch != null;
                }).length;
                
                if (openedBranches > 3)
                    overFlowEl.animate({
                        scrollLeft: overFlowEl.get()[0].scrollWidth + 'px'
                    }, 'fast');
            }

            scope.$watch('newFolder', function (newValue, oldValue) {
                if (newValue !== oldValue) {
                    selectedNode.children.push(newValue);
                }
            });

            scope.$watch('tree', function (newValue, oldValue) {
                if (!initialized) {
                    //On environments other than local, oldValue often is the same as newValue in the very first watch trigger.
                    //Thus the line '|| oldValue !== undefined'
                    if (newValue !== oldValue || oldValue !== undefined)
                        init(scope.tree[0]);
                }
            });

        },
        templateUrl: '/../Templates/Partials/Templates/horizontalTreeControl.html' + '?v=' + DoohConfig.version
    }
}]);